'use client'

import { useRouter } from 'next/navigation'

import e_application_SA_CA_FCCA from '@/assets/images/e_application_SA_CA_FCCA.svg'
import { LinkButton } from '@/components/buttons'
import Link from '@/components/Link'

const QARD_SA = () => {
  const router = useRouter()
  return (
    <div className="text-grey-color">
      <ul>
        <li>
          <a
            href="https://www.alrajhibank.com.my/assets/compressed/Qard Savings4.zip"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            Click here
          </a>{' '}
          to download and complete all forms:
        </li>
        <div>1.&emsp;Account Opening / Placement Form</div>
        <div>2.&emsp;Tax Residency Self-Certification Form</div>
      </ul>
      <ul>
        <li>Complete the following form to get a mystery gift from preferred branch:</li>
        <div>3.&emsp;Investor Suitability and Risk Assessment Form</div>
      </ul>
      <ul>
        <li>If you are a US Citizen/US Tax Resident/US Indicia, complete as follows:</li>
        <div>4.&emsp;For US Citizen/US Tax Resident, complete FATCA W-9 Form</div>
        <div>5.&emsp;For US Indicia, complete FATCA W-8BEN Form</div>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You are not required to sign-off all the Forms when you submit this application. The
        signing of these Forms will be performed during your visit to the Branch after the account
        is opened.
      </div>
      <ul>
        <li>Scan and attach the following supporting documents with your application:</li>
      </ul>
      <img src={e_application_SA_CA_FCCA.src} width="100%" alt="e_application_SA_CA_FCCA" />
      <div className="my-3 d-flex gap-3">
        <LinkButton
          text="Product Information"
          onClick={() => router.push('/personal/deposits/savings-account')}
        />
      </div>
      <ul>
        <li>
          Submit all of the above to{' '}
          <a href="mailto:onlineaccountopening@alrajhibank.com.my">
            onlineaccountopening@alrajhibank.com.my
          </a>
        </li>
      </ul>
      <div className="p-2 border rounded background-indigo my-3">
        Note: You will be notified to visit your selected branch to activate your account during
        banking hours.
      </div>
    </div>
  )
}

export default QARD_SA
